import { render, staticRenderFns } from "./crList.vue?vue&type=template&id=d6b6a00a&scoped=true"
import script from "./crList.vue?vue&type=script&lang=js"
export * from "./crList.vue?vue&type=script&lang=js"
import style0 from "./crList.vue?vue&type=style&index=0&id=d6b6a00a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b6a00a",
  null
  
)

export default component.exports